// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const ToastDescription = createStyle({
  flex: 1,
  minWidth: 0,
  color: '$textLight700',
  _dark: {
    color: '$textDark200',
  },
  props: {
    size: 'sm',
  },
});
